export const GET_SAFETY_SETTINGS = 'GET_SAFETY_SETTINGS';
export const GET_SAFETY_SETTINGS_DONE = 'GET_SAFETY_SETTINGS_DONE';
export const GET_SAFETY_SETTINGS_ERR = 'GET_SAFETY_SETTINGS_ERR';
export const SET_SAFETY_SETTINGS = 'SET_SAFETY_SETTINGS';
export const SET_SAFETY_SETTINGS_DONE = 'SET_SAFETY_SETTINGS_DONE';
export const SET_SAFETY_SETTINGS_ERR = 'SET_SAFETY_SETTINGS_ERR';
export const RESET_SAFETY_SETTINGS = 'RESET_SAFETY_SETTINGS';
//# sourceMappingURL=actionTypes.js.map